import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "text-center q-my-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_async_btn = _resolveComponent("async-btn")!

  return (_ctx.result.captcha)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_q_img, {
          src: _ctx.result.captcha.imageUrl,
          class: "q-my-md full-width"
        }, null, 8, ["src"]),
        _createElementVNode("form", {
          onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.solve && _ctx.solve(...args)), ["prevent"]))
        }, [
          _createVNode(_component_q_input, {
            modelValue: _ctx.solution,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.solution) = $event)),
            placeholder: "Enter the chacters you see above",
            outlined: ""
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_async_btn, {
              task: _ctx.task,
              type: "submit",
              label: "Continue",
              color: "primary",
              class: "full-width",
              rounded: ""
            }, null, 8, ["task"])
          ])
        ], 32)
      ]))
    : _createCommentVNode("", true)
}